module.exports = __webpack_public_path__ + "media/images/icons/icn_027-c2885d3f8c0f76886a7b53f2df527a3e.svg";